export default "This files was empty\n"